import { render, staticRenderFns } from "./layer-assets-import.vue?vue&type=template&id=2eb38c98&scoped=true&"
import script from "./layer-assets-import.vue?vue&type=script&lang=js&"
export * from "./layer-assets-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb38c98",
  null
  
)

export default component.exports